const EmailHeader = () => {
 
  return (
    <div>
      <h1>This is email header</h1>      
    </div>
  );
};

export default EmailHeader;